"use client";

import { iconCls } from "@faire/slate/lib/tracking";
import React from "react";

import { createSVGIcon } from "../lib/iconUtils";

/**
 * @trackcomponent
 * @figma designed by Nick MacDougall (see [Figma](https://figma.com/file/qcB5qVN7uKBBYHN49ihDE7?node-id=1837%3A423))
 * @donotsync Syncing adds default color (@quinlan.sokol)
 * @optimized using svgo:^3.0.2
 */
export const Storefront = createSVGIcon(
  <>
    <path
      d="M2.9 13.48a.5.5 0 1 0-1 0zm-.5 9.12h-.5a.5.5 0 0 0 .5.5zm19.2 0v.5a.5.5 0 0 0 .5-.5zm.5-9.12a.5.5 0 1 0-1 0zm-7.68 0a.5.5 0 1 0-1 0zm7.68 9.12v-9.12h-1v9.12zm-19.7.5h11.52v-1H2.4zm11.52 0h7.68v-1h-7.68zm-.5-9.62v9.12h1v-9.12zm-11.52 0v2.88h1v-2.88zm0 2.88v6.24h1v-6.24zm.5.5h11.04v-1H2.4z"
      fill="currentColor"
    />
    <path
      d="M3.36 1h17.28L23 6.76H1z"
      stroke="currentColor"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M.5 6.76a.5.5 0 0 1 .5-.5h14.396q.13.001.24.061a.5.5 0 0 1 .239-.061h7.188a.5.5 0 0 1 .5.5v1.409c0 2.132-1.876 3.786-4.094 3.786-1.726 0-3.245-1.001-3.834-2.45-.589 1.449-2.107 2.45-3.833 2.45-1.534 0-2.905-.791-3.604-1.985-.7 1.194-2.07 1.985-3.604 1.985C2.376 11.955.5 10.301.5 8.17zm1 .5v.909c0 1.498 1.342 2.786 3.094 2.786S7.688 9.667 7.688 8.17V7.26zm7.208 0v.909c0 1.498 1.342 2.786 3.094 2.786s3.094-1.288 3.094-2.786V7.26zm7.667.909V7.26h6.188v.909c0 1.498-1.343 2.786-3.094 2.786-1.752 0-3.094-1.288-3.094-2.786"
      fill="currentColor"
    />
  </>,
  "Storefront",
  { viewBox: "0 0 24 24", fill: "none", className: iconCls() } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
